import { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { driverPaymentRepository } from "../data/driverPaymentRepository";
import { getLastDriverPaymentUseCase } from "../domain/getLastDriverPaymentUseCase";

function formatAmount(amount) {
  return amount == null ? "—" : Number(amount).toFixed(2);
}

function formatDate(value) {
  if (!value) return "Sin fecha";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "Sin fecha" : date.toLocaleString("es-PE");
}

export function LastDriverPayment({ driverId }) {
  const [result, setResult] = useState(null);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    setResult(null);

    async function loadPayment() {
      const response = await getLastDriverPaymentUseCase(driverPaymentRepository, driverId);
      if (active) setResult(response);
    }

    loadPayment();
    return () => {
      active = false;
    };
  }, [driverId, attempt]);

  const payment = result?.data;

  return (
    <Box sx={{ p: 1.25, borderRadius: 2, border: "1px solid #e4e7ec", bgcolor: "#f9fafb" }}>
      {!result ? (
        <Box display="flex" alignItems="center" gap={1} role="status">
          <CircularProgress size={18} sx={{ color: "#165c53" }} />
          <Typography>Cargando último pago/cobro…</Typography>
        </Box>
      ) : result.error ? (
        <>
          <Typography role="alert" sx={{ color: "#b42318" }}>{result.error}</Typography>
          <Button onClick={() => setAttempt((current) => current + 1)} sx={{ color: "#165c53" }}>
            Reintentar
          </Button>
        </>
      ) : payment ? (
        <PaymentDetails payment={payment} />
      ) : (
        <Typography>No hay pagos/cobros registrados.</Typography>
      )}
    </Box>
  );
}

function PaymentDetails({ payment }) {
  return (
    <Box sx={{ overflowWrap: "anywhere" }}>
      <Typography>Fecha: {formatDate(payment.date)}</Typography>
      <Typography>Importe: {formatAmount(payment.amount)}</Typography>
      <Typography>Adelanto: {formatAmount(payment.advance)}</Typography>
      <Typography sx={{ whiteSpace: "pre-wrap" }}>Notas: {payment.notes || "Sin notas"}</Typography>
    </Box>
  );
}
